
































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { EntitiesFilesService } from "@/services/api/entities.files.service";
import entityPermissions from "@/permissions/entity.permissions";
import { EntityFileDto, LanguageDto, EntityDto } from "@/server/app.dtos";
import { GetEntityFilesDtosQuery } from "@/server/app.queries";

@Component
export default class DetailEntitySideMenuComponent extends BaseSideComponent {
  CdnUrl: string = process.env.VUE_APP_CDN_URL;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  entityPermissions: entityPermissions = new entityPermissions();
  entitiesFilesService: EntitiesFilesService = new EntitiesFilesService();
  files: EntityFileDto[] = [];
  isLoading: boolean = false;
  isValid: boolean = false;

  constructor() {
    super();
    if (this.CdnUrl.endsWith("/")) {
      this.CdnUrl = this.CdnUrl.substring(0, this.CdnUrl.length - 1);
    }
  }

  get entity(): EntityDto | null {
    return this.args?.entity || null;
  }

  canView(): boolean {
    if (this.entity)
      return this.entityPermissions.canView(this.entity) || false;
    return false;
  }

  canEdit(): boolean {
    if (this.entity)
      return this.entityPermissions.canEdit(this.entity) || false;
    return false;
  }

  async created() {
    await this.loadFiles();
  }

  async loadFiles() {
    if (this.entity) {
      const request = new GetEntityFilesDtosQuery();
      request.isPublic = true;
      request.idEntity = this.entity.idEntity;

      await this.entitiesFilesService
        .GetFiles(request)
        .then(response => (this.files = response.data));
    }
  }
}
